module.exports = __webpack_public_path__ + "static/media/Spotify_Icon_RGB_White.cc4e2784.png";